var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "url(#paint0_linear_13098_11846)",
    stroke: "#234B9E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13098_11846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 20.8335H10.3335V19.6668C10.3335 18.8933 10.6408 18.1514 11.1878 17.6044C11.7347 17.0575 12.4766 16.7502 13.2502 16.7502H16.7502C17.5237 16.7502 18.2656 17.0575 18.8126 17.6044C19.3595 18.1514 19.6668 18.8933 19.6668 19.6668V20.8335ZM15.0002 15.5835C14.5405 15.5835 14.0854 15.493 13.6608 15.3171C13.2361 15.1412 12.8503 14.8834 12.5253 14.5584C12.2003 14.2334 11.9425 13.8475 11.7666 13.4229C11.5907 12.9982 11.5002 12.5431 11.5002 12.0835C11.5002 11.6239 11.5907 11.1687 11.7666 10.7441C11.9425 10.3195 12.2003 9.93363 12.5253 9.60862C12.8503 9.28362 13.2361 9.02581 13.6608 8.84992C14.0854 8.67403 14.5405 8.5835 15.0002 8.5835C15.9284 8.5835 16.8187 8.95224 17.475 9.60862C18.1314 10.265 18.5002 11.1552 18.5002 12.0835C18.5002 13.0118 18.1314 13.902 17.475 14.5584C16.8187 15.2147 15.9284 15.5835 15.0002 15.5835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13098_11846",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13098_11846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5af004896ab04c75f545a3a3e2ec02a3.svg";
export { ForwardRef as ReactComponent };